module.exports = __webpack_public_path__ + "static/media/fika.aaea2a7e.png";